import { render } from "./PhotosSegment.vue?vue&type=template&id=55501b80&ts=true"
import script from "./PhotosSegment.vue?vue&type=script&lang=ts"
export * from "./PhotosSegment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__